<template>
  <div class="layout-box">
    <LayoutHeader></LayoutHeader>
    <div class="secondary-content">
      <div class="pallet-box">
        <div class="pallet-box1">
          <div class="pallet-box-lr" style="width: 32.5%">
            <div style="height: 23%; color: #fff; text-align: center">
              <h2 style="padding-top: 10%; font-size: 28px">38</h2>
              <span style="font-size: 12px; color: #9D9DA4">合作化纤工厂</span>
            </div>
            <h3 style="color: #fff; font-size: 16px; padding: 10px; border-top: 1px solid #374E7F;">注册平台会员</h3>
            <vue-seamless-scroll :data="clientlist" :class-option="classOption" class="seamless-warp">
              <ul class="client-group">
                <li v-for="(item,index) in clientlist" :key="index">{{item.memberName}}</li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <div class="pallet-box-lr" style="width: 65.6%" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)">
            <echartschina :configs="myconfigchina" ref="child"></echartschina>
          </div>
        </div>
        <div class="pallet-box2">
          <div class="pallet-box-lr" style="width: 65.6%; position: relative" v-loading="loading2" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 17px;">托盘占用时间分析</h3>
            <div id="machartpie" style="width: 100%; height: 100%"></div>
          </div>
          <div class="pallet-box-lr" style="width: 32.5%;position: relative">
            <h3 style="text-align: left;width: 100%; padding-left: 12px; margin-top: 12px; font-size: 17px;">客户画像</h3>
            <a title="人数：2750" style="font-size: 32px; color: #2E88FF; position: absolute; left: 50%; top: 50%; margin-top: -21px; margin-left: -48px">低库存</a>
            <a title="人数：2339" style="font-size: 28px; color: #FE8433; position: absolute; left: 50%; top: 50%; margin-top: 16px; margin-left: -40px">VIP客户</a>
            <a title="人数：1464" style="font-size: 26px; color: #1FD3CD; position: absolute; left: 50%; top: 50%; margin-top: -51px; margin-left: -88px">DTY</a>
            <a title="人数：1095" style="font-size: 26px; color: #6D6DF2; position: absolute; left: 50%; top: 50%; margin-top: -51px; margin-left: 0px">POY</a>
            <a title="人数：950" style="font-size: 24px; color: #4CA2DC; position: absolute; left: 50%; top: 50%; margin-top: -91px; margin-left: -98px">外围客户</a>
            <a title="人数：851" style="font-size: 21px; color: #ECA90A; position: absolute; left: 50%; top: 50%; margin-top: 71px; margin-left: -98px">贸易商</a>
            <a title="人数：750" style="font-size: 18px; color: #DB7295; position: absolute; left: 50%; top: 50%; margin-top: 81px; margin-left: 48px">不良客户</a>
            <a title="人数：607" style="font-size: 18px; color: #89A7FA; position: absolute; left: 50%; top: 50%; margin-top: -101px; margin-left: 38px">危险预警</a>
            <a title="人数：562" style="font-size: 18px; color: #30A19E; position: absolute; left: 50%; top: 50%; margin-top: 53px; margin-left: 38px">高周转率</a>
            <a title="人数：347" style="font-size: 18px; color: #F593B4; position: absolute; left: 50%; top: 50%; margin-top: -51px; margin-left: 68px">FDY</a>
          </div>
        </div>
      </div>
      <div class="pallet-box">
        <div class="pallet-box2">
          <div class="pallet-box-lr is-flex" style="width: 32.5%">
            <div style="border-bottom: 1px solid #374E7F;">
              <span style="font-size: 12px; color: #9D9DA4">托盘使用次数</span>
              <h2 style="font-size: 30px"><countTo :startVal='0' :endVal='summary.usetimes/10000' :decimals="1" :duration='100'></countTo><em style="font-size: 21px;font-style: normal">万</em></h2>
            </div>
            <div style="border-top: 1px solid #374E7F;">
              <span style="font-size: 12px; color: #9D9DA4">运营托盘总量</span>
              <h2 style="font-size: 30px"><countTo :startVal='0' :endVal='summary.allnum/10000' :decimals="1" :duration='100'></countTo><em style="font-size: 21px;font-style: normal">万</em></h2>
            </div>
          </div>
          <div class="pallet-box-lr" style="width: 65.6%; padding: 10px 20px; position: relative" v-loading="loading3" element-loading-background="rgba(0, 0, 0, 0.1)">
            <h3 style="position: absolute; top: 12px; left: 12px; font-size: 17px;">地区回收占比</h3>
            <div id="machartpie2" style="width: 100%; height: 100%"></div>
          </div>
        </div>
        <div class="pallet-box1">
          <div class="pallet-box-lr is-flex" style="width: 65.6%">
            <h3 style="text-align: left;width: 100%; padding-left: 50px; font-size: 18px; color: #1A7DFE">运营模式</h3>
            <img src="../../assets/pallet-yyms.gif" style="width: 95%; height: auto"/>
          </div>
          <div class="pallet-box-lr" style="width: 32.5%; padding: 20px 18px; line-height: 172%; font-size: 18px; text-indent: 2em; border-style: dashed">
            <h3 style="text-align: left;width: 100%; padding-left: 50px; font-size: 12px">&nbsp;</h3>
            <p>久鼎智能托盘运营模式打破网点限制，实现自由流转。基于互联网技术平台实现监控追踪，第三方维修，押金制和按流转次数计费。</p>
            <p style="margin-top: 12px">以产品租赁集成化管理的业务形式满足聚酯化纤产业链上下游包装物料共享循环使用需求，为工厂提供塑托使用回收一站式服务。</p>
            <p style="margin-top: 12px">通过搭建共享托盘租赁平台，集成射频RFID、视觉颜色识别、条码、智能仓储等技术，实现托盘、货物全流程追溯，全生命周期管理。</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "./pallet-header";
import {getTime} from "../../bll/utils";
import echartschina from "../../components/china";
import countTo from 'vue-count-to';
export default {
  name: 'PalletIndex',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    LayoutHeader,
    echartschina,
    countTo
  },
  data () {
    return {
      clientlist:[
        {
          "memberName": "杭****缆有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "金****纱有限公司"
        },
        {
          "memberName": "长****技有限公司"
        },
        {
          "memberName": "晋****造有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "石****饰有限公司"
        },
        {
          "memberName": "嘉****料有限公司"
        },
        {
          "memberName": "海****百乐化纤厂"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "广****织有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "绍****料有限公司"
        },
        {
          "memberName": "桐****品有限公司"
        },
        {
          "memberName": "浙****料有限公司"
        },
        {
          "memberName": "诸****化纤经营部"
        },
        {
          "memberName": "杭****缆有限公司"
        },
        {
          "memberName": "长****织有限公司"
        },
        {
          "memberName": "宣****料有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "江****料有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "绍****纺有限公司"
        },
        {
          "memberName": "江****纤有限公司"
        },
        {
          "memberName": "山****网有限公司"
        },
        {
          "memberName": "盐****易有限公司"
        },
        {
          "memberName": "海****其丙纺织厂"
        },
        {
          "memberName": "佛****技有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "杭****易有限公司"
        },
        {
          "memberName": "南****布有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "江****纤有限公司"
        },
        {
          "memberName": "安****品有限公司"
        },
        {
          "memberName": "桐****业有限公司"
        },
        {
          "memberName": "厦****贸有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "安****品有限公司"
        },
        {
          "memberName": "安****业有限公司"
        },
        {
          "memberName": "厦****技有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "桐****技有限公司"
        },
        {
          "memberName": "晋****织有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "张****造有限公司"
        },
        {
          "memberName": "苏****纤有限公司"
        },
        {
          "memberName": "嘉****品有限公司"
        },
        {
          "memberName": "泉****限责任公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "常****品有限公司"
        },
        {
          "memberName": "常****易有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "杭****有限公司 "
        },
        {
          "memberName": "湖****织有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "吴****宁顺喷织厂"
        },
        {
          "memberName": "仪****纤有限公司"
        },
        {
          "memberName": "上****技有限公司"
        },
        {
          "memberName": "晋****造有限公司"
        },
        {
          "memberName": "滨****网有限公司"
        },
        {
          "memberName": "太****纤有限公司"
        },
        {
          "memberName": "浙****份有限公司"
        },
        {
          "memberName": "宁****织有限公司"
        },
        {
          "memberName": "浙****易有限公司"
        },
        {
          "memberName": "吴****造有限公司"
        },
        {
          "memberName": "嘉****份有限公司"
        },
        {
          "memberName": "海****编有限公司"
        },
        {
          "memberName": "福****技有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "浙****料有限公司"
        },
        {
          "memberName": "浙****染有限公司"
        },
        {
          "memberName": "绍****技有限公司"
        },
        {
          "memberName": "江****维有限公司"
        },
        {
          "memberName": "杭****料有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "湖****织有限公司"
        },
        {
          "memberName": "苏****纤有限公司"
        },
        {
          "memberName": "杭****前交卫布厂"
        },
        {
          "memberName": "苏****限责任公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "诸****织有限公司"
        },
        {
          "memberName": "四****品有限公司"
        },
        {
          "memberName": "吴****限责任公司"
        },
        {
          "memberName": "嘉****织有限公司"
        },
        {
          "memberName": "浙****技有限公司"
        },
        {
          "memberName": "海****弹有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "宁****绒有限公司"
        },
        {
          "memberName": "江****织有限公司"
        },
        {
          "memberName": "海****万群加弹厂"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "诸****织有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "浦****织有限公司"
        },
        {
          "memberName": "浙****份有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "长****织有限公司"
        },
        {
          "memberName": "湖****织有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "广****技有限公司"
        },
        {
          "memberName": "普****造有限公司"
        },
        {
          "memberName": "绍****料有限公司"
        },
        {
          "memberName": "诸****织有限公司"
        },
        {
          "memberName": "青****带有限公司"
        },
        {
          "memberName": "绍****纺有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "杭****料有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "长****纤有限公司"
        },
        {
          "memberName": "太****纤有限公司"
        },
        {
          "memberName": "桐****份有限公司"
        },
        {
          "memberName": "海****技有限公司"
        },
        {
          "memberName": "晋****纤有限公司"
        },
        {
          "memberName": "绍****贸有限公司"
        },
        {
          "memberName": "惠****网有限公司"
        },
        {
          "memberName": "天****品有限公司"
        },
        {
          "memberName": "苏****技有限公司"
        },
        {
          "memberName": "石****易有限公司"
        },
        {
          "memberName": "夏****品有限公司"
        },
        {
          "memberName": "瑞****纤有限公司"
        },
        {
          "memberName": "嘉****料有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "杭****料有限公司"
        },
        {
          "memberName": "长****技有限公司"
        },
        {
          "memberName": "海****技有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "嘉****技有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "钦****装饰经营部"
        },
        {
          "memberName": "南****纤有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "吴****品有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "杭****技有限公司"
        },
        {
          "memberName": "苏****纤有限公司"
        },
        {
          "memberName": "苏****源有限公司"
        },
        {
          "memberName": "晋****易有限公司"
        },
        {
          "memberName": "诸****源祥化纤厂"
        },
        {
          "memberName": "杭****品有限公司"
        },
        {
          "memberName": "吴****织有限公司"
        },
        {
          "memberName": "滨****品有限公司"
        },
        {
          "memberName": "绍****纺有限公司"
        },
        {
          "memberName": "海****品有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "杭****纤有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "绍****装弹力丝厂"
        },
        {
          "memberName": "福****易有限公司"
        },
        {
          "memberName": "福****业有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "惠****网有限公司"
        },
        {
          "memberName": "湖****技有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "长****纺有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "浙****口有限公司"
        },
        {
          "memberName": "常****织有限公司"
        },
        {
          "memberName": "嵊****纤有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "苏****饰有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        },
        {
          "memberName": "蚌****织有限公司"
        },
        {
          "memberName": "盐****裕华加捻厂"
        },
        {
          "memberName": "太****纤有限公司"
        },
        {
          "memberName": "宿****织有限公司"
        },
        {
          "memberName": "普****造有限公司"
        },
        {
          "memberName": "安****技有限公司"
        },
        {
          "memberName": "浙****纤有限公司"
        },
        {
          "memberName": "海****利弹力丝厂"
        },
        {
          "memberName": "诸****事达化纤厂"
        },
        {
          "memberName": "绍****饰有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "吴****贸有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "宿****织有限公司"
        },
        {
          "memberName": "杭****织有限公司"
        },
        {
          "memberName": "杭****纤有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "福****易有限公司"
        },
        {
          "memberName": "绍****纤有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "杭****品有限公司"
        },
        {
          "memberName": "绍****织有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "苏****织有限公司"
        },
        {
          "memberName": "诸****纤有限公司"
        },
        {
          "memberName": "昌****织有限公司"
        },
        {
          "memberName": "海****织有限公司"
        },
        {
          "memberName": "绍****品有限公司"
        }
      ],
      myconfigchina:{
        formatter:function(e, t, n) {
          let data = e.data;
          let context=''
          if(data){
            context = `
               <div>
                   <p><b style="font-size:15px;">${data.name}</b></p>
                   <p class="tooltip_style"><span class="tooltip_left">数量和：</span><span class="tooltip_right">${data.value}家</span></p>
               </div>
            `
          }
          return context;
        },
        pieces: [
          { gte: 3800, label: "", color: "#0036CC" },
          { gte: 2800, lt: 3799, label: "", color: "#0F67E2" },
          { gte: 1800, lt: 2799, label: "", color: "#106FEF" },
          { gte: 200, lt: 1799, label: " ", color: "#4794EF" },
          { gte: 50, lt: 199, label: ' ', color: "#81BEF7" },
          { lt: 49, label: ' ', color: "#C2E6FF" }
        ],
        areaColor:'#2F3952',
        dataList:[{
          name: "南海诸岛",
          value: 0
        }],
      },
      summary:{
        allnum:0,
        list:[],
        usetimes:0
      },
      loading:true,
      loading2:true,
      loading3:true,
    }
  },
  computed:{
    classOption(){
      return{
        step:0.1,// 数值越大速度滚动越快
        limitMoveNum:2,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop:true,// 是否开启鼠标悬停stop
        direction:1,// 0向下 1向上 2向左 3向右
        openWatch:true,// 开启数据实时监控刷新dom
        singleHeight:0,// 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth:0,// 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime:1000,// 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  mounted () {
    const $this=this
    setTimeout(function () {
      $this.getdata()
    },500)
    $this.dataRefresh.$ons('Refresh', () => {
      $this.getdata()
    })
  },
  methods:{
    getdata(){
      const $this=this
      const url = '/api-portal/pallet/areapersent';
      $this.$api.post(url, {}, (response) => {
        let datas=response.data||''
        if(datas){
          let arr=datas.data.map(val => {
            return {name:val.branchName,value:val.num}
          })
          $this.drawpiechart('machartpie2',arr,'回收数量')
          this.loading2 = false
        }
      })
      const url2 = '/api-portal/pallet/custom';
      $this.$api.post(url2, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.myconfigchina.dataList=datas.data
          this.$refs.child.setEchartOption()
          this.$refs.child.initEchartMap()
          this.loading = false
        }
      })
      const url3 = '/api-portal/pallet/summary';
      $this.$api.post(url3, {}, (response) => {
        let datas=response.data||''
        if(datas){
          $this.summary=datas.data
          let arr=datas.data.list.map(val => {
            return {name:val.typeName,value:val.recycleCount}
          })
          $this.drawpiechart('machartpie',arr,'回收数量')
          this.loading3 = false
        }
      })
    },
    drawpiechart (id,data,name) {
      const myEchartst = this.$echarts.init(document.getElementById(id))
      let option = {
        title: {
          show: false
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            return `${params.marker}${params.name}<br>${params.seriesName}：${(params.value/10000).toFixed(1)} 万 （${params.percent}%）`
          }
        },
        color:['#2E88FF','#FE8433','#1FD3CD','#6D6DF2','#4CA2DC','#FFB70A','#DB7295','#89A7FA','#34ADA9','#EE6666','#7178BC','#CFA67C','#73C0DE','#5470C6'],
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'right',
          top: 'center',
          icon:'path://M85.333333 85.333333m53.333334 0l746.666666 0q53.333333 0 53.333334 53.333334l0 746.666666q0 53.333333-53.333334 53.333334l-746.666666 0q-53.333333 0-53.333334-53.333334l0-746.666666q0-53.333333 53.333334-53.333334Z',
          textStyle:{
            color:'#BDBDC1'
          }
        },
        series: [
          {
            name: name,
            type: 'pie',
            radius: '60%',
            data: data,
            label: {
              show: true,
              formatter:`{b} \n{d}%`,
              textStyle:{
                color:'#F4F7FF'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      myEchartst.setOption(option)
    }
  }
}
</script>

<style scoped>
.layout-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
  top:0;
  left: 0;
  background: #060614 url("../../assets/bjs.png") no-repeat top/100%;
}

.secondary-content{
  width: 100%;
  height: calc(100% - 20px);
  padding: 0 10px;
  padding-top: 152px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}

.pallet-box{
  box-sizing: border-box;
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction:column;
  justify-content: space-between;
  align-items: center;
}

.pallet-box>div{
  box-sizing: border-box;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.pallet-box1{
  height: 60%;
}

.pallet-box2{
  height: 38.7%;
}

.pallet-box-lr{
  border: 1px solid #374E7F;
  box-sizing: border-box;
  height: 100%;
}

.is-flex{
  display: flex;
  flex-direction:column;
  justify-content: space-around;
  align-items: center;
}

.is-flex>div{
  width: 100%;
  height: 46.5%;
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  line-height: 150%;
}

.seamless-warp{
  overflow: hidden;
  height: 67%;
}

.client-group{
  padding: 5px 10px;
}

.client-group li{
  background: rgba(9,42,92,.65);
  color: #D2FBFF;
  font-size: 14px;
  height: 24px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
  border-left: 1px solid #35FEA9;
  line-height: 24px;
  margin: 5px 0;
}

.pallet-box-lr a{
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/pallet/pallet-index.vue